import { CriteriaSubjectReverseMap, CriteriaComparisonReverseMap, SuccessCriteria } from '../../models/project/SuccessCriteria';

import * as _ from 'lodash';

const ProjectCriteriaParser = {
  mapSuccessCriteria(criteria?: {
    subject: string,
    comparison: string,
    amount: number,
    description?: string,
    custom_estimate_title?: string
  }) {
    if (_.isUndefined(criteria)) {
      return undefined;
    } else {
      // "Keep in mind that string enum members do not get a reverse mapping generated at all."
      const subject = _.find(CriteriaSubjectReverseMap, (cs) => { return cs === criteria.subject; });
      if (_.isUndefined(subject)) {
        throw 'Error while parsing project success criteria subject from string: ' + criteria.subject;
      }
      const comparison = _.find(CriteriaComparisonReverseMap, (cs) => { return cs === criteria.comparison; });
      if (_.isUndefined(comparison)) {
        throw 'Error while parsing project success criteria comparison from string: ' + criteria.comparison;
      }
      if (!_.isNumber(criteria.amount)) {
        throw 'Error while parsing project success criteria amount, not a number: ' + criteria.amount;
      }
  
      return new SuccessCriteria(subject, comparison, criteria.amount, criteria.description, criteria.custom_estimate_title);
    }
  }
};

export default ProjectCriteriaParser;


// WEBPACK FOOTER //
// ./src/services/project/ProjectCriteriaParser.ts